<template>
  <v-file-input
                density="compact"
                label="Selecionar arquivo"
                filled
                :rules="rules"
                :prepend-icon="icon"
                :accept="acceptType"
                :disabled="requestingApi"
                v-model="inputFile"
                @change="uploadFile"></v-file-input>
</template>
<script>
import api from '@/services'

export default {
  props: {
    icon: String,
    acceptType: String,
    fileType: Number,
    userId: Number,
    legalPersonId: Number,
    groupId: Number,
    subGroupId: Number,
    eventId: Number,
  },
  data() {
    return {
      requestingApi: false,
      inputFile: null,
      rules: [
        value => {
          return !value || !value.length || value[0].size < 5000000 || 'O tamanho do arquivo deve ser menor que 5MB'
        },
      ],
    };
  },
  created() { },
  mounted() { },
  activated() { },
  methods: {
    uploadFile(event) {
      let _file = event?.target?.files[0] || null
      var vm = this;
      vm.requestingApi = true;
      api.file
        .upload(_file, {
          fileType: vm.fileType,
          user_id: vm.userId,
          legal_person_id: vm.legalPersonId,
          group_id: vm.group_id,
          subgroup_id: vm.subGroupId,
          event_id: vm.eventId
        })
        .then((result) => {
          vm.$emit("uploaded", result);
          vm.$notify({
            type: "success",
            text: "Arquivo enviado com sucesso",
          });
          vm.inputFile = null
        })
        .catch((err) => {
          if (err.message) {
            vm.$notify({
              type: "warn",
              text: err.message,
            });
          }
        })
        .finally(() => {
          vm.requestingApi = false;
        });
    },
  },
};
</script>